import { HttpAxios } from "@/common/services/httpAxios";

/**
 * @description service para obter lista de alertas
 * @see http://beta-api-insights-bff.socialminer.tech/swagger/index.html - Beta com vpn ativa
 * @see http://api-insights-bff.socialminer.tech/swagger/index.html - Prod com vpn ativa
 */
class Monitoring {
  async getAllAlerts(): Promise<any> {
    try {
      const response = await HttpAxios.bffInsights.get(`/Monitoring`);
      return response.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

export default new Monitoring();
